export default __webpack_public_path__ + "static/media/thumb-GNSS-Receiver-4.6185edb8.png";